// extracted by mini-css-extract-plugin
export var addToCartButton = "_qg-b";
export var arrowButtonContainer = "_qg-9";
export var arrowButtonIcon = "_qg-a";
export var carouselArrowButton = "_qg-6";
export var carouselElementContainer = "_qg-1";
export var left = "_qg-7";
export var productDisplayCarouselContainer = "_qg-0";
export var productTileContainer = "_qg-2";
export var productTileImage = "_qg-4";
export var productTileImageContainer = "_qg-3";
export var productTileTitle = "_qg-5";
export var right = "_qg-8";
export var sliderOverflow = "_qg-c";